export default __webpack_public_path__ + "static/annHappy-cd2de7e6ab274754f6aaed7cf978bf3c.png";